import { View, Text } from "@react-pdf/renderer";

const s = {
  bold: { fontFamily: "Helvetica-Bold" },
  row: { display: "flex", flexDirection: "row", gap: 4 },
  col: { display: "flex", flexDirection: "column", gap: 4 },
};

export const CustomListPDF = ({
  items,
  startNumber = 1,
  textAlign = "justify",
}) => {
  const processText = (text) => {
    const parts = text.split(/\*\*(.*?)\*\*/);
    return parts.map((part, index) => {
      if (index % 2 === 1) {
        return (
          <Text key={index} style={s.bold}>
            {part}
          </Text>
        );
      }
      return <Text key={index}>{part}</Text>;
    });
  };

  return (
    <>
      {items.map((item, index) => {
        const gapBullet = item.bullet ? { gap: 15 } : { gap: 2 };
        return (
          <View key={index} style={[s.row, gapBullet]}>
            <Text>{item.bullet ? item.bullet : index + startNumber + "."}</Text>
            <Text style={{ textAlign: textAlign }}>
              {processText(item.text)}
            </Text>
          </View>
        );
      })}
    </>
  );
};
